import React, { useContext, useRef, useState } from 'react';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getEResources } from '../../NecttosComp/APICaller/ApiServices';
import { useDropDowns } from '../../NecttosComp/APICaller/queryHooks';
import { Body, closeAnimation, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';
import { Table, Thead, Th, Tbody, Tr, Td } from '../../NecttosComp/Table/Table';
import Instruction from '../../Documentation/Instruction';

export const EResources = ({ onClose }) => {
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const { data = [], refetch } = useQuery('getEResources', getEResources(collegeId));
	const [isLoading, setIsLoading] = useState(false);
	const [state, setState] = useState({});
	const { data: dropDown } = useDropDowns('library');
	const [showForm, setShowForm] = useState(false);

	const manageHolidays = async () => {
		try {
			setIsLoading(true);
			if (!state.title) {
				throw new Error('Title is Empty');
			}
			const instance = await getAxiosTokenInstance();
			let resp;
			resp = await instance.post('/college/action/postEResources', {
				collegeId,
				title: state?.title,
				link: state?.link,
				type: state?.type,
				_id: state?._id,
			});
			if (resp.data.statusCode !== 200) {
				throw new Error(resp.data.message || 'API Error');
			} else {
				setState({
					...state,
					title: '',
					link: '',
					type: '',
					_id: '',
				});
				refetch();
			}
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			setIsLoading(false);
		}
	};

	const handleAddNew = () => {
		setState({
			title: '',
			link: '',
			type: '',
			_id: '',
		});
		setShowForm(true);
	};

	const handleEdit = (item) => {
		setState({
			...state,
			title: item?.title || '',
			link: item?.link || '',
			type: item?.type || '',
			_id: item?._id || '',
		});
		setShowForm(true);
	};

	return (
		<Main height='100%' width='100%' title='E Resources Management'>
			<Header>
				<div className='flex'></div>
				<div className='flex'>
					<Button type='update' onClick={handleAddNew}>
						Add New
					</Button>
					<Button
						type='fetch'
						onClick={() => {
							refetch();
						}}>
						Reload
					</Button>
					<Button type='print' tableRef={componentRef.current}>
						Print
					</Button>
<Instruction keyId={'eResources'}/>
					{!isLoading && (
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					)}
				</div>
			</Header>

			<Body>
				<div ref={componentRef} className='printable rounded-xl'>
					<div className='flex flex-col p-4 w-full overflow-x-auto'>
						<div className='min-w-[700px]'>
							<Table width='100%' innerWidth={['5%', '20%', '40%', '25%', '10%']}>
								<Thead>
									<Tr>
										<Th position={0} textAlign='center'>
											Sn
										</Th>
										<Th position={1}>Type</Th>
										<Th position={2}>Title of the Link</Th>
										<Th position={3}>Link</Th>
										<Th position={4} textAlign='center'></Th>
									</Tr>
								</Thead>
								<Tbody height='70vh'>
									{data?.map((item, i) => (
										<Tr key={i} index={i}>
											<Td position={0} index={i} textAlign='center'>
												{i + 1}
											</Td>
											<Td position={1} index={i}>
												{item?.type}
											</Td>
											<Td position={2} index={i}>
												{item?.title}
											</Td>
											<Td position={3} index={i}>
												{item?.link}
											</Td>
											<Td position={4} index={i} textAlign='center'>
												<div className='no-print print:hidden'>
													<Button type='edit' onClick={() => handleEdit(item)}>
														Edit
													</Button>
												</div>
											</Td>
										</Tr>
									))}
								</Tbody>
							</Table>
						</div>
					</div>
				</div>
			</Body>

			{showForm && (
				<div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
					<Main width='40vw' height='80vh' title={state._id ? 'Edit E Resource' : 'Add New'}>
						<Header>
							<div className='flex'></div>
							<div className='flex'>
								<Button
									type='close'
									onClick={() => {
										closeAnimation();
										setTimeout(() => setShowForm(false), 500);
									}}>
									Close
								</Button>
							</div>
						</Header>
						<Body>
							<div>
								<Input2 type='text' fieldName='Title of the Link' returnKey='title' state={state} setState={setState} className='w-[96%]' />

								<Input2 type='text' fieldName='Paste Link here' returnKey='link' state={state} setState={setState} className='w-[96%]' />

								<Input2 type='drop' fieldName='Type of E Resources' returnKey='type' state={state} setState={setState} options={dropDown?.eResources || []} className='w-[96%] dark:text-white' />

								<div className='flex justify-between'>
									<Button
										type='close'
										onClick={() => {
											setState({
												...state,
												title: '',
												link: '',
												type: '',
												_id: '',
												alert: '',
											});
										}}>
										Reset
									</Button>
									<Button type='submit' onClick={manageHolidays}>
										Submit
									</Button>
								</div>
							</div>
						</Body>
					</Main>
				</div>
			)}
		</Main>
	);
};
